import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthServiceApi {

  constructor(private http: HttpClient) { }

    changePassword(body) {
      return this.http.post(`${environment.apiUrl}/common/auth/changepassword`, body,{
          headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
      })
    }


}
